import { motion } from "framer-motion";

const SOS_PLAYER_COLORS = ["#06b6d4", "#ec4899", "#a855f7", "#eab308"];

export const SOSScorePanel = ({ 
  scores = [0, 0],
  currentPlayer = 1,
  playerNames = ["Player 1", "Player 2"],
  playerCount = 2,
}) => {
  const activeNames = playerNames.slice(0, playerCount);
  const activeScores = scores.slice(0, playerCount);

  return (
    <motion.div
      initial={{ y: -20, opacity: 0 }}
      animate={{ y: 0, opacity: 1 }}
      transition={{ duration: 0.5 }}
      className="glass-card-strong rounded-2xl p-3 sm:p-4 mb-4 w-full max-w-2xl mx-auto"
      data-testid="sos-score-panel"
    >
      <div className="grid gap-2" style={{ gridTemplateColumns: `repeat(${playerCount}, 1fr)` }}>
        {activeNames.map((name, i) => (
          <div 
            key={i}
            data-testid={`sos-score-player${i + 1}`}
            className={`text-center p-2 rounded-lg border-2 transition-all ${currentPlayer === i + 1 ? 'scale-105' : 'opacity-70'}`}
            style={{ 
              borderColor: currentPlayer === i + 1 ? SOS_PLAYER_COLORS[i] : 'transparent',
              background: currentPlayer === i + 1 ? `${SOS_PLAYER_COLORS[i]}12` : 'transparent',
            }}
          >
            <div className={`font-fredoka text-xs sm:text-sm font-bold truncate ${currentPlayer === i + 1 ? 'animate-pulse' : ''}`}
              style={{ color: SOS_PLAYER_COLORS[i] }}>
              {name}
            </div>
            <div className="font-fredoka text-xl sm:text-2xl font-bold" style={{ color: SOS_PLAYER_COLORS[i] }}>
              {activeScores[i] || 0}
            </div>
          </div>
        ))}
      </div>
    </motion.div>
  );
};

export default SOSScorePanel;
